import { Palette } from '@mui/material'

export const editIcon = (palette: Palette) => ({
	color: palette.text.lightGrey,
	marginLeft: '8px',
	width: '1rem',
	alignSelf: 'center',
	cursor: 'pointer',
})

export const dialogTitleStyle = {
	fontSize: '22px',
	fontWeight: 700,
	lineHeight: '20pt',
	marginBottom: '16px',
	paddingTop: '12px',
}
